import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconMySettings } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { showMySettingsToolBox } from '../../actions';
/**
 * Implementation of a button for showing sub menu toolbar.
 */
class MySettingsButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.mySettings';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.exitFullScreen';
        this.label = 'toolbar.mySettings';
        this.tooltip = 'toolbar.mySettings';
        this.icon = IconMySettings;
    }
    _isToggled() {
        return this.props.mySettingsToolboxVisible;
    }
    /**
    * Handles clicking the button, and show sub menu.
    *
    * @private
    * @returns {void}
    */
    _handleClick(event) {
        const { dispatch, mySettingsToolboxVisible } = this.props;
        event?.stopPropagation();
        sendAnalytics(createToolbarEvent('MySettings'));
        dispatch(showMySettingsToolBox(!mySettingsToolboxVisible));
    }
}
MySettingsButton.defaultProps = {
    ...AbstractButton.defaultProps,
    customClass: 'mySettingsButton',
};
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        mySettingsToolboxVisible: state['features/toolbox'].mySettingsVisible,
        // visible: !isIosMobileBrowser()
        //It is required to show the button on IosBrowser
        visible: true
    };
};
export default translate(connect(mapStateToProps)(MySettingsButton));
